import dayjs from 'dayjs';
import { profileService } from 'domains/auth/profile.service';
import { Cookies } from 'domains/common/cookies/server';
import { productsService } from 'domains/products/products.service';
import { PaymentsPageServerAbstract } from 'domains/common/server/payments-page.server.abstract';
import type { GetServerSidePropsContext } from 'next';

import type { AppStore } from 'redux-store';

import { actions } from '../web-special-offer';

const promoTimerCookieKey = 'limitStartCold';

export class WebSpecialOfferService extends PaymentsPageServerAbstract {
  private timerLogic({
    context,
    store,
  }: {
    context: GetServerSidePropsContext;
    store: AppStore;
  }): void {
    const timerCookie = context.req.cookies[promoTimerCookieKey] as
      | string
      | undefined;

    let limitStart = timerCookie || new Date().toISOString();

    const diff = dayjs().diff(limitStart);
    const duration = dayjs.duration(diff);

    if (duration.asMinutes() >= 20) {
      limitStart = new Date().toISOString();
    }

    const cookies = new Cookies(context);
    cookies.add(promoTimerCookieKey, limitStart, { maxAge: 60 * 60 }).save();

    store.dispatch(actions.showTimer({ start: limitStart }));
  }
  async server({
    context,
    store,
    screen = 'web-special-offer'
  }: {
    context: GetServerSidePropsContext;
    store: AppStore;
    screen?: string;
  }): Promise<void> {
    const coupon = context.query.coupon as string | undefined;
    const isAuthenticated = context.req.cookies.welltorysessionid;

    await this.timerLogic({ context, store });

    if (isAuthenticated) {
      await profileService.getProfile({ store }, context);
    }

    await Promise.allSettled([
      super.server({
        context,
        store,
      }),
      productsService.getProductsV3({ store, screen, coupon }, context),
    ]);
  }
}
